export default {
  profile(state) {
    return state.profile
  },

}
